/** Shared action-category colour tokens — the approved Home "My Action Centre · Quick Actions" treatment (soft tinted card +
 *  solid icon tile, rounded-lg), reused by QuickActionCard (every module) and the Button action variants. Same category = same
 *  colour on every route. Static class strings so Tailwind keeps them. Destructive stays rose / `destructive` semantics. */
export const ACTION_TONES = {
  create: { card: "bg-violet-50 border-violet-200 hover:border-violet-400", icon: "bg-violet-600 text-white" },
  manage: { card: "bg-sky-50 border-sky-200 hover:border-sky-400", icon: "bg-sky-600 text-white" },
  ops: { card: "bg-teal-50 border-teal-200 hover:border-teal-400", icon: "bg-teal-600 text-white" },
  finance: { card: "bg-amber-50 border-amber-200 hover:border-amber-400", icon: "bg-amber-500 text-white" },
  comms: { card: "bg-green-50 border-green-200 hover:border-green-400", icon: "bg-green-600 text-white" },
  compliance: { card: "bg-fuchsia-50 border-fuchsia-200 hover:border-fuchsia-400", icon: "bg-fuchsia-600 text-white" },
  danger: { card: "bg-rose-50 border-rose-200 hover:border-rose-400", icon: "bg-rose-600 text-white" },
};

const RULES = [
  ["danger", /(^|[-_])(delete|remove|void|revoke|archive|cancel|block|suspend)/],
  ["comms", /(^|[-_])(wa|whatsapp|email|mail|message|msg|enquiry|enq|call|chat|feedback|nps|notify|send|reply|inbox|tele)/],
  ["finance", /(^|[-_])(followup|invoice|inv|payment|pay|receipt|ar|credit|bank|statement|remind|price|pricing|cost|margin|finance|gst|tds|ledger|cash|collect|vault)/],
  ["ops", /(^|[-_])(dispatch|delivery|dc|challan|ship|track|stock|inventory|fulfil|address|pick|pack|warehouse|grn|courier|serial|transfer|logistic|command|order|label)/],
  ["compliance", /(^|[-_])(kyc|compliance|audit|legal|consent|policy)/],
  ["create", /(^|[-_])(add|new|create|quote|dup|duplicate|upload|import|register|onboard)/],
];

/** Category for a quick action / button key (e.g. "add-customer" → create, "dispatch-tracking" → ops). Default: manage. */
export function toneFor(key = "") {
  const k = String(key).toLowerCase();
  return (RULES.find(([, rx]) => rx.test(k)) || ["manage"])[0];
}
